import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProfile from "../common/MyProfile";
import { useAuth } from "../context/UserContext";
import { Link } from "react-router-dom";

const MyEarning = () => {
  const { user } = useAuth();
  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <div
          className="container mt-4 removetopspace "
          style={{ paddingTop: "170px" }}
        >
          <div className="row">
            <MyProfile />

            <div className="col-md-7">
              <h4 className="fw-bold"> Balance</h4>
              <div
                className="card p-3 shadow-sm d-flex flex-row justify-content-between align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <span className="fw-bold fs-4">
                  {user ? user[0]?.wallet : "0"}
                </span>
                <Link
                  to="/earn-and-refer"
                  className="btn btn-success"
                  style={{ height: "35px", width: "150px" }}
                >
                  REDEEM NOW
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyEarning;
